/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { ResellerWizardStore } from './reseller-wizard-store';

export const ResellerWizardStoreContext = createContext<ResellerWizardStore>({} as ResellerWizardStore);
